const parseClassnames = (baseCls, extraCls)=>{
    const baseClasses = baseCls ? baseCls.split(' ') : [];
    const extraClasses = extraCls ? extraCls.split(' ') : [];
    let classNames = baseClasses.join(' ');
    extraClasses.forEach((extra)=>{
        if (!extra) return;
        const cls = '-' === extra.substr(0, 1) ? extra.substring(1) : extra;
        const prefix = cls.replace('tw-', '').split('-')[0];
        const repeated = baseClasses.find((c)=>c.includes(`${prefix}-`));
        if (!repeated) classNames = classNames.concat(classNames.length ? ' ' : '', extra);
    });
    return classNames;
};
const helpers_parseClassnames = parseClassnames;
export default helpers_parseClassnames;
